/**
 * Utility class for handling Tizen app versions.
 */
export default class TizenAppsVersionUtil {
  static getVersionString(version: string | number): string {
    return typeof version === 'number' ? String(version) : version;
  }

  /**
   * Compares two versions part by part (e.g. "5.17.3" vs "5.17").
   * Returns a negative number if version1 < version2, 0 if equal,
   * a positive number if version1 > version2.
   */
  static compareVersions(version1: string | number, version2: string | number): number {
    const parts1 = this.getVersionString(version1).split('.').map(Number);
    const parts2 = this.getVersionString(version2).split('.').map(Number);
    const length = Math.max(parts1.length, parts2.length);
    for (let i = 0; i < length; i++) {
      const diff = (parts1[i] || 0) - (parts2[i] || 0);
      if (diff !== 0) {
        return diff;
      }
    }
    return 0;
  }

  static compare(version1: string | number, version2: string | number): boolean {
    return this.compareVersions(version1, version2) === 0;
  }

  static greaterThan(version1: string | number, version2: string | number): boolean {
    return this.compareVersions(version1, version2) > 0;
  }

  static difference(version1: string | number, version2: string | number): number {
    return this.compareVersions(version1, version2);
  }

  static lessThan(version1: string | number, version2: string | number): boolean {
    return this.compareVersions(version1, version2) < 0;
  }
}
